export default __webpack_public_path__ + "static/media/leader_notes_detailed.bdaf43b4.pdf";